import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { Redirect, Route, Switch } from "react-router-dom";
import urls from "../../global/constants/UrlConstants";
import layoutStyles from "./Layout.styles";
import { useMediaQuery, useTheme } from "@mui/material";
import strings from "../../global/constants/StringConstants";
import AppHeader from "../AppHeader/AppHeader";
import AppDrawer from "../AppDrawer/AppDrawer";
import {
  drawerWidthExpanded,
} from "../../utils/styles";
import PrivateRoute from "../../global/components/PrivateRoute/PrivateRoute";
import AccountSettings from "../../screens/AccountSettings/AccountSettings";
import CompanyInfo from "../../screens/AccountSettings/components/Company/Company";
import OrganizationsAdmin from "../../screens/Organizations/OrganizationsAdmin";
import OrgIntegrationsPage from "../../screens/Organizations/OrgIntegrationsPage";
import AuditLogsPage from "../../screens/Organizations/AuditLogsPage";
import ChannelPartnersPage from "../../screens/ChannelPartners/ChannelPartnersPage";
import ChannelPartnerDetailPage from "../../screens/ChannelPartners/ChannelPartnerDetailPage";
import ChannelPartnerAddLeadPage from "../../screens/ChannelPartners/ChannelPartnerAddLeadPage";
import {
  CpBulkUploadPage,
  CpBulkUploadSetsPage,
  LeadsBulkUploadPage,
  LeadsBulkUploadSetsPage,
  CallDatasetUploadPage,
} from "../../screens/BulkUploadWizard/pages";
import CallDatasetsPage from "../../screens/CallDatasets/CallDatasetsPage";
import SecurityPage from "../../screens/AccountSettings/components/Security/Security";
import SystemSettingsPage from "../../screens/AccountSettings/components/SystemSettings/SystemSettings";
import AccountProfilePage from "../../screens/AccountSettings/components/Profile/AccountProfilePage";
import AccountPreferencesPage from "../../screens/AccountSettings/components/AccountStatus/AccountStatus";
import MetaData from "../../screens/MetaData/MetaData";
import MetaList from "../../screens/MetaData/components/MetaList/MetaList";
import AddDepartmentPage from "../../screens/MetaData/components/MetaList/components/AddTeamMatadata/AddTeamMatadata";
import Settings from "../../screens/Settings/Settings";
import Team from "../../screens/Team/Team";
import AddNewTeam from "../../screens/Team/components/AddNewTeam/AddNewTeam";
import Attendance from "../../screens/Attendance/Attendance";
import AllAttendance from "../../screens/Attendance copy/Attendance";
import AllLeaves from "../../screens/Leave copy/Leave";
import SalarySlip from "../../screens/SalarySlip/SalarySlip";
import PulseDashboards from "../../screens/DashBoard/PulseDashboards";
import { useAppSelector } from "../../utils/hooks";
import { selectAuthenticated } from "../../redux/authSlice";
import Leave from "../../screens/Leave/Leave";
import { motion } from "framer-motion";
import { selectIsDrawerOpen } from "../../redux/userDataSlice";
import Dashboard from "../../screens/DashBoard/Dashboard";
import Project from "../../screens/Project/Project";
import CreateProject from "../../screens/Project/CreateProject";
import AllLeads from "../../screens/AllLeads/Team";
import AllLeadsDetails from "../../screens/AllLeads/AllLeadsDetails";
import AddLeadPage from "../../screens/AllLeads/components/AddNewTeam/AddNewTeam";
import HometatvaLeads from "../../screens/HometatvaLeads/Team";
import myLead from "../../screens/MyLead/Team";
import bulkUpload from "../../screens/BulkUpload/Team";
import ImportLeadPage from "../../screens/BulkUpload/components/exportLead/AddNewTeam";
import RolesPrivileges from "../../screens/RolesPrivileges/RolesPrivileges";
import AddRolePage from "../../screens/AccountSettings/components/Role/AddRole/Role";
import LeadForm from "../../screens/Lead/LeadForm";
import AddLeadFormPage from "../../screens/Lead/components/AddNewTeam/AddNewTeam";
import FeedbackPage from "../../screens/Feedback/FeedbackPage";
import RegistrationsPage from "../../screens/Registrations/RegistrationsPage";
import PaymentsPage from "../../screens/Payments/PaymentsPage";
import WhatsAppMarketingPage from "../../screens/Marketing/WhatsAppMarketingPage";
import WhatsAppBroadcastCreatePage from "../../screens/Marketing/WhatsAppBroadcastCreatePage";
import WhatsAppBroadcastDetailPage from "../../screens/Marketing/WhatsAppBroadcastDetailPage";
import UserManualPage from "../../screens/UserManual/UserManualPage";
import Report from "../../screens/Report/Report";
import SourceReport from "../../screens/SourceReport/Report/Report";
import VisitReport from "../../screens/VisitReport/Report/Report";
import ProjectReport from "../../screens/ProjectReport/Report/Report";
import ClosureReport from "../../../src/screens/ClosureReport/Report";
import ArchiveTeam from "../../../src/screens/ArchiveTeam/Team";
import ViewLoansPage from "../../screens/ArchiveTeam/components/AddLoan/ViewLoansPage";
import BulkAssignComp from "../../screens/BulkAssign/Team"
import BulkUploadeProjectwiseComp from "../../screens/BulkUploadeProjectWise/Team"
import ImportLeadProjectwisePage from "../../screens/BulkUploadeProjectWise/components/exportLead2/AddNewTeam"
import AggregatorApi from "../../screens/AggregatorApi/Team"
import MetaStage from "../../screens/MetaData/components/MetaList/MetaStage";
import TeamMetaList from "../../screens/MetaData/components/MetaList/components/TeamMetaList/teamMetaList";
import HierarchyMetaList from "../../screens/MetaData/components/MetaList/components/CompanyHierarchyList/companyHierarchyList";
import GradeList from "../../screens/MetaData/components/MetaList/components/GradeList/GradeList";
import LeadSourceList from "../../screens/MetaData/components/MetaList/components/LeadSourceList/LeadSourceList";
import ArchiveLead from "../../screens/ArchiveLead/Team"
import UnmergedLeadsPage from "../../screens/ArchiveLead/UnmergedLeadsPage"
import MetaProjectList from "../../screens/MetaData/components/MetaList/MetaProjectList";
import TeamLeads from "../../screens/TeamLeads/Team";
import FacebookAds from "../../screens/FacebookAds/Team";
import CallLogs from "../../screens/CallLogs/Team";
import CallingReport from "../../screens/CallLogs/CallingReport";
import ProjectLocationMetaList from "../../screens/MetaData/components/MetaList/components/ProjectLocationList/projectLocationList";
import ProjectFilterMetaData from "../../screens/MetaData/components/MetaList/components/ProjectFilterMeta";
import AddProjectMatadata from "../../screens/MetaData/components/MetaList/components/AddProjectMetaData/AddProjectMatadata";
import MeetingList from "../../screens/Meeting/MeetingList";
import CreateMeeting from "../../screens/Meeting/CreateMeeting/CreateMeeting";
import BookingList from "../../screens/Booking/BookingList";
import CustomerList from "../../screens/Customer/CustomerList";
import CustomerDetails from "../../screens/Customer/CustomerDetails";
import EnquiryList from "../../screens/CMS/Enquiry/EnquiryList";
import LocationList from "../../screens/MetaData/components/MetaList/components/SectorList/LocationList";
import ZoneList from "../../screens/MetaData/components/MetaList/components/ZoneList/ZoneList";
import { Service } from "aws-sdk";
import ServiceLeadList from "../../screens/ServiceLeads/ServiceLeadList";
import SubscribeLeadList from "../../screens/Subscribe/SubscribeList";
import AutomationList from "../../screens/Automation/AutomationList";
import AutomationEditor from "../../screens/Automation/AutomationEditor";

interface CustomProps {
  location?: Location;
}

const Layout = (props: CustomProps) => {
  const classes = layoutStyles;
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);
  const isAuthenticated: any = useAppSelector(selectAuthenticated);
  const [toggle, setToggle] = useState(false);
  const theme = useTheme();
  const isDesktop = useMediaQuery(theme.breakpoints.up("md"));
  const [open, setOpen] = useState<boolean>(true);
  const [sidebarWidth, setSidebarWidth] = useState<number>(
    drawerWidthExpanded
  );

  // const location = props.location?.pathname?.split("/")[1].toLowerCase();
  const isDrawerOpenFromRedux: any = useAppSelector(selectIsDrawerOpen);

  // useEffect(() => {
  //   setOpen(isDrawerOpenFromRedux);
  // }, []);
  const toggleDrawer = () => {
    setIsDrawerOpen(!isDrawerOpen);
  };

  const getContent = () => {
    const sidebarW = sidebarWidth;
    return (
      <Box
        sx={{
          ...classes.content,
          width: `calc(100% - ${sidebarW}px)`,
          transition: "width 0.25s ease",
        }}
      >
        <Switch>
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.dashboardViewPath}
            component={PulseDashboards}
            componentName={strings.DASHBOARD}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.dashboardViewPathCrm}
            component={PulseDashboards}
            componentName={strings.DASHBOARDCRM}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.dashboardViewPathHr}
            component={Dashboard}
            componentName={strings.DASHBOARDHR}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.dashboardViewPathMy}
            component={PulseDashboards}
            componentName={strings.DASHBOARDMY}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.attendanceViewpath}
            component={Attendance}
            componentName={strings.ATTENDANCE}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.myattendanceViewpath}
            component={AllAttendance}
            componentName={strings.ATTENDANCE}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.allLeaveViewPath}
            component={AllLeaves}
            componentName={strings.ATTENDANCE}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountSettingsViewPth}
            component={AccountSettings}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountOrganizationPath}
            component={OrganizationsAdmin}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path="/setting/account/company-profile"
            component={CompanyInfo}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountSecurityPath}
            component={SecurityPage}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountSystemPath}
            component={SystemSettingsPage}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountProfilePath}
            component={AccountProfilePage}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountPreferencesPath}
            component={AccountPreferencesPage}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.organizationsAdminPath}
            component={OrganizationsAdmin}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.accountIntegrationsPath}
            component={OrgIntegrationsPage}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.automationLeadFlowPath}
            component={AutomationList}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.automationLeadFlowNewPath}
            component={AutomationEditor}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.automationLeadFlowEditPath}
            component={AutomationEditor}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.auditLogsPath}
            component={AuditLogsPage}
            componentName={strings.SETTINGS}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.leaveViewPath}
            component={Leave}
            componentName={strings.LEAVE}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.salarySlipViewPath}
            component={SalarySlip}
            componentName={strings.SALARYSLIP}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.TeamDashboardViewpath}
            component={PulseDashboards}
            componentName={strings.TEAMDASHBOARD}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaDataViewPath}
            component={MetaData}
            componentName={strings.SETTINGS}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaListViewPath}
            component={MetaList}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ADDDEPARTMENTPAGE}
            component={AddDepartmentPage}
            componentName={strings.SETTINGS}
          />
  <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaStageListPath}
            component={MetaStage}
            componentName={strings.SETTINGS}
          />           <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaTeamListViewPath}
            component={TeamMetaList}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaHierarchyListViewPath}
            component={HierarchyMetaList}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaGradeListPath}
            component={GradeList}
            componentName={strings.SETTINGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaLeadSourcesPath}
            component={LeadSourceList}
            componentName={strings.SETTINGS}
          />

<PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaProjectListPath}
            component={MetaProjectList}
            componentName={strings.SETTINGS}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.settingsViewPath}
            component={Settings}
            componentName={strings.SETTINGS}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.teamViewPath}
            component={Team}
            componentName={strings.TEAM}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.addTeamViewPath}
            component={AddNewTeam}
            componentName={strings.TEAM}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.editTeamViewPath}
            component={AddNewTeam}
            componentName={strings.TEAM}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.rolesPrivilegesViewPath}
            component={RolesPrivileges}
            componentName={strings.ROLESANDPRIVILEGES}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ADDROLEPAGE}
            component={AddRolePage}
            componentName={strings.ROLESANDPRIVILEGES}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.EDITROLEPAGE}
            component={AddRolePage}
            componentName={strings.ROLESANDPRIVILEGES}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ALLLEADFORMLIST}
            component={AllLeads}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.channelPartnersPath}
            component={ChannelPartnersPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.cpBulkUploadSetsPath}
            component={CpBulkUploadSetsPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.cpBulkUploadPath}
            component={CpBulkUploadPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.cpAddLeadPath}
            component={ChannelPartnerAddLeadPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.channelPartnerDetailPath}
            component={ChannelPartnerDetailPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.leadsBulkUploadSetsPath}
            component={LeadsBulkUploadSetsPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.leadsBulkUploadPath}
            component={LeadsBulkUploadPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.callDatasetUploadPath}
            component={CallDatasetUploadPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.callDatasetsPath}
            component={CallDatasetsPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ADDLEADPAGE}
            component={AddLeadPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.EDITLEADPAGE}
            component={AddLeadPage}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ALLLEADDETAILS}
            component={AllLeadsDetails}
            componentName={strings.LEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.HOMETATVALEADFORMLIST}
            component={HometatvaLeads}
            componentName={strings.HometatvaLeads}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.HOMETATVALEADDETAILS}
            component={AllLeadsDetails}
            componentName={strings.HometatvaLeads}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ADDHOMETATVALEADPAGE}
            component={AddLeadPage}
            componentName={strings.HometatvaLeads}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.EDITHOMETATVALEADPAGE}
            component={AddLeadPage}
            componentName={strings.HometatvaLeads}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.mylead}
            component={myLead}
            componentName={strings.MYLEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.MYLEADADDPAGE}
            component={AddLeadPage}
            componentName={strings.MYLEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.MYLEADEDITPAGE}
            component={AddLeadPage}
            componentName={strings.MYLEADS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.bulkUploade}
            component={bulkUpload}
            componentName={strings.BULKUPLOADE}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.IMPORTLEADPAGE}
            component={ImportLeadPage}
            componentName={strings.BULKUPLOADE}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={`${urls.CREATEPROJECT}/:id`}
            component={CreateProject}
            componentName={strings.PROJECTS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.CREATEPROJECT}
            component={CreateProject}
            componentName={strings.PROJECTS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.PROJECTS}
            component={Project}
            componentName={strings.PROJECTS}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.LEADFORMLIST}
            component={LeadForm}
            componentName={strings.LEADFORMLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.ADDLEADFORMPAGE}
            component={AddLeadFormPage}
            componentName={strings.LEADFORMLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.EDITLEADFORMPAGE}
            component={AddLeadFormPage}
            componentName={strings.LEADFORMLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.FEEDBACKLIST}
            component={FeedbackPage}
            componentName={strings.FEEDBACKLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.REGISTRATIONSLIST}
            component={RegistrationsPage}
            componentName={strings.REGISTRATIONSLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.PAYMENTLIST}
            component={PaymentsPage}
            componentName={strings.PAYMENTLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.whatsappMarketingCreatePath}
            component={WhatsAppBroadcastCreatePage}
            componentName={strings.WHATSAPP_MARKETING}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.whatsappMarketingDetailPath}
            component={WhatsAppBroadcastDetailPage}
            componentName={strings.WHATSAPP_MARKETING}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.whatsappMarketingPath}
            component={WhatsAppMarketingPage}
            componentName={strings.WHATSAPP_MARKETING}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.userManualPath}
            component={UserManualPage}
            componentName={strings.USER_MANUAL}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.preSalesReports}
            component={Report}
            componentName={strings.PRESALESREPORT}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.salesReports}
            component={VisitReport}
            componentName={strings.LEADFORMLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.projectReports}
            component={ProjectReport}
            componentName={strings.LEADFORMLIST}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.sourceReports}
            component={SourceReport}
            componentName={strings.LEADFORMLIST}
          />
          {/* <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.siteVisitReports}
            component={VisitReport}
            componentName={strings.LEADFORMLIST}
          /> */}
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.closureReports}
            component={ClosureReport}
            componentName={strings.CLOSUREREPORT}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.archiveMember}
            component={ArchiveTeam}
            componentName={strings.ARCHIVEMEMBER}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.addArchiveTeamViewPath}
            component={AddNewTeam}
            componentName={strings.ARCHIVEMEMBER}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.editArchiveTeamViewPath}
            component={AddNewTeam}
            componentName={strings.ARCHIVEMEMBER}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.viewArchiveLoanPath}
            component={ViewLoansPage}
            componentName={strings.ARCHIVEMEMBER}
          />

          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.bulkAssign}
            component={BulkAssignComp}
            componentName={strings.BULKASSIGN}
          />

<PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.archiveLead}
            component={ArchiveLead}
            componentName={strings.ARCHIVELEAD}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.unmergedLeads}
            component={UnmergedLeadsPage}
            componentName={strings.UNMERGEDLEADS}
          />
            <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.bulkUploadeProjectwise}
            component={BulkUploadeProjectwiseComp}
            componentName={strings.BULKUPLOADEPROJECTWISE}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.IMPORTLEADPROJECTWISEPAGE}
            component={ImportLeadProjectwisePage}
            componentName={strings.BULKUPLOADEPROJECTWISE}
          />

           <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.aggregatorApi}
            component={AggregatorApi}
            componentName={strings.BULKUPLOADEPROJECTWISE}
          />
            <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.teamleads}
            component={TeamLeads}
            componentName={strings.TEAMLEADS}
          />
                <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.facebookAds}
            component={FacebookAds}
            componentName={strings.FACEBOOKADS}
          />

             <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.callLogs}
            component={CallLogs}
            componentName={strings.CALLLOGS}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.callingReport}
            component={CallingReport}
            componentName={strings.CALLINGREPORT}
          />
          <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaProjectLocationListViewPath}
            component={ProjectLocationMetaList}
            componentName={strings.SETTINGS}
          />
            <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.locationListViewPath}
            component={LocationList}
            componentName={strings.SETTINGS}
          />
            <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaProjectZonesListViewPath}
            component={ZoneList}
            componentName={strings.SETTINGS}
          />
              <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaProjectFilterListViewPath}
            component={ProjectFilterMetaData}
            componentName={strings.SETTINGS}
          />
            <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.metaProjectListViewPath}
            component={AddProjectMatadata}
            componentName={strings.SETTINGS}
          />
           <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.meetingListViewPath}
            component={MeetingList}
            componentName={strings.MEETING}
          />
              <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.createMeetingViewPath}
            component={CreateMeeting}
            componentName={strings.CREATEMEETING}
          />
              <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.bookingListViewPath}
            component={BookingList}
            componentName={strings.BOOKING}
          />
              <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.customerDetailsPath}
            component={CustomerDetails}
            componentName={strings.CUSTOMER}
          />
              <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.customerListViewPath}
            component={CustomerList}
            componentName={strings.CUSTOMER}
          />
              <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.enquiryViewPath}
            component={EnquiryList}
            componentName={strings.ENQUIRY}
          />

            <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.serviceLeadsViewPath}
            component={ServiceLeadList}
            componentName={strings.SERVICELEADS}
          />
             <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.subscribeLeadsViewPath}
            component={SubscribeLeadList}
            componentName={strings.SUBSCRIBELEADS}
          />
          {/* <PrivateRoute
            exact
            isLoggedIn={isAuthenticated}
            path={urls.teamViewPath}
            component={() => {
              <Team setToggle={setToggle} toggle={toggle} />;
            }}
            componentName={strings.TEAM}
          /> */}
          <Route
            path={"/*"}
            component={() => {
              return <>Page not found</>;
            }}
          />
        </Switch>
      </Box>
    );
  };

  const getLayout = () => {
    // Unauthenticated users must never stay on protected admin URLs
    if (!isAuthenticated) {
      return (
        <Redirect
          to={{
            pathname: urls.loginViewPath,
            state: { from: props.location },
          }}
        />
      );
    }

    const sidebarW = sidebarWidth;
    // Do not start at opacity 0 — if the main thread stalls, the UI stays blank forever.
    // Do not hide page content when viewport < md (DevTools side panel often drops below md).
    return (
      <motion.div initial={false} animate={{ opacity: 1 }}>
        <AppHeader
          sidebarWidth={sidebarW}
          onToggleSidebar={() => setOpen((v) => !v)}
        />
        <Box sx={classes.root}>
          {isDesktop ? (
            <AppDrawer
              open={open}
              setOpen={setOpen}
              onSidebarWidthChange={setSidebarWidth}
            />
          ) : null}
          {getContent()}
        </Box>
      </motion.div>
    );
  };

  return getLayout();
};

export default Layout;
